class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, 'remove');
      const completeYourLookContainer = document.querySelector('.complete_your_look-drawer_cart');
      // console.log('completeYourLookContainer', completeYourLookContainer)
      if (completeYourLookContainer) {
        const links = completeYourLookContainer.querySelectorAll('a[data-hide-href]');
        links.forEach((link) => {
          const dataHideHref = link.getAttribute('data-hide-href');
          if (dataHideHref) {
            link.setAttribute('href', dataHideHref);
          }
        });
        // console.log('test data hide src')
        const images = completeYourLookContainer.querySelectorAll('img[data-hide-src]');
        images.forEach((image) => {
          // console.log('image', image)
          const dataHideImage = image.getAttribute('data-hide-src');
          const dataHideSrcSet = image.getAttribute('data-hide-srcset');
          if (dataHideImage) {
            image.setAttribute('src', dataHideImage);
            image.setAttribute('srcset', dataHideSrcSet);
          }
        });
      }
      setTimeout(() => {
        productCardsSizes();
      }, 1000);
      setTimeout(() => {
        const allWishlistItems = document.getElementById('wishlist')?.querySelectorAll('wishlist-product-card');
        if (allWishlistItems) {
          const wishlistCountItem = document.getElementById('wishlist-count');
          if (allWishlistItems && allWishlistItems != null) {
            wishlistCountItem.innerText = allWishlistItems.length;
          }
        }
      }, 1000);
      setTimeout(() => {
        const completeYourLookContainer = document.querySelector('.complete_your_look-drawer_cart');
        if (completeYourLookContainer) {
          const links = completeYourLookContainer.querySelectorAll('a[data-hide-href]');
          links.forEach((link) => {
            const dataHideHref = link.getAttribute('data-hide-href');
            if (dataHideHref) {
              link.setAttribute('href', dataHideHref);
            }
          });

          const images = completeYourLookContainer.querySelectorAll('img[data-hide-src]');
          images.forEach((image) => {
            const dataHideImage = image.getAttribute('data-hide-src');
            const dataHideSrcSet = image.getAttribute('data-hide-srcset');
            if (dataHideImage) {
              image.setAttribute('src', dataHideImage);
              image.setAttribute('srcset', dataHideSrcSet);
            }
          });
        }
      }, 1000);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = document.getElementById(`Quantity-${id}`) || document.getElementById(`Drawer-quantity-${id}`);
    console.log('input', input);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
    productCardsSizes();
  }

  onCartUpdate() {
    console.log('onCartUpdate');
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        productCardsSizes();
        setTimeout(() => {
          const completeYourLookContainer = document.querySelector('.complete_your_look-drawer_cart');
          if (completeYourLookContainer) {
            const links = completeYourLookContainer.querySelectorAll('a[data-hide-href]');
            links.forEach((link) => {
              const dataHideHref = link.getAttribute('data-hide-href');
              if (dataHideHref) {
                link.setAttribute('href', dataHideHref);
              }
            });

            const images = completeYourLookContainer.querySelectorAll('img[data-hide-src]');
            images.forEach((image) => {
              const dataHideImage = image.getAttribute('data-hide-src');
              const dataHideSrcSet = image.getAttribute('data-hide-srcset');
              if (dataHideImage) {
                image.setAttribute('src', dataHideImage);
                image.setAttribute('srcset', dataHideSrcSet);
              }
            });
          }
        }, 100);

        const url = document.location.href;
        const urlObj = new URL(url);

        const getParamValues = (param) => {
          return [...new URLSearchParams(urlObj.search).entries()]
            .filter(([key, value]) => key.includes(param))
            .map(([key, value]) => value);
        };

        const color = getParamValues('filter.v.option.color');
        const size = getParamValues('filter.v.option.talla');
        const minPrice = urlObj.searchParams.get('filter.v.price.gte');
        const maxPrice = urlObj.searchParams.get('filter.v.price.lte');
        const orderBy = urlObj.searchParams.get('sort_by');

        let filters = [];

        if (color.length > 0) filters.push(`color:${color.join(',')}`);
        if (size.length > 0) filters.push(`talla:${size.join(',')}`);
        if (minPrice !== null || maxPrice !== null) {
          let priceRange = `${minPrice || '0'}-${maxPrice || '∞'}`;
          filters.push(`precio:${priceRange}`);
        }
        if (orderBy !== null) filters.push(`ordenar por:${orderBy}`);

        const viewListId = `${document.title.split(' | ')[0]}|F:${filters.length > 0 ? filters.join(',') : 'N/A'}`;

        const model = lineItem?.getAttribute('data-product-model')?.replace('*', '');
        const stock = lineItem?.getAttribute('data-product-score-stock');
        const scoreStock = calcularScoreStock(lineItem?.getAttribute('data-product-score-stock'));
        const availableSizes = getAvailableAndUnavailableSizes(
          lineItem?.getAttribute('data-product-score-stock')
        ).available;
        const unavailableSizes = getAvailableAndUnavailableSizes(
          lineItem?.getAttribute('data-product-score-stock')
        ).unavailable;
        let typeOfProduct = '';
        // console.log('name remove 2', name)
        if (name == 'minus' || name == 'remove') {
          typeOfProduct = parsedState?.items_removed[0]?.product_type;
        } else {
          typeOfProduct = parsedState?.items_added[0]?.product_type;
        }
        let itemCategory2 = '';
        if (
          typeOfProduct == 'Anillos' ||
          typeOfProduct == 'Collares' ||
          typeOfProduct == 'Pendientes' ||
          typeOfProduct == 'Pulseras'
        ) {
          itemCategory2 = 'Bisutería';
        } else if (
          typeOfProduct == 'Bolsos' ||
          typeOfProduct == 'Bufandas' ||
          typeOfProduct == 'Calcetines' ||
          typeOfProduct == 'Calzado' ||
          typeOfProduct == 'Cinturones' ||
          typeOfProduct == 'Gafas' ||
          typeOfProduct == 'Gorros' ||
          typeOfProduct == 'Monederos'
        ) {
          itemCategory2 = 'Accesorios';
        } else if (typeOfProduct == 'Abrigos' || typeOfProduct == 'Gabardinas') {
          itemCategory2 = 'Abrigos y Gabardinas';
        } else if (typeOfProduct == 'Bañador' || typeOfProduct == 'Baño') {
          itemCategory2 = 'Baño';
        } else if (typeOfProduct == 'Blusas' || typeOfProduct == 'Camisas') {
          itemCategory2 = 'Camisas y Blusas';
        } else if (typeOfProduct == 'Camisetas') {
          itemCategory2 = 'Camisetas';
        } else if (typeOfProduct == 'Chalecos') {
          itemCategory2 = 'Chalecos';
        } else if (typeOfProduct == 'Kimonos' || typeOfProduct == 'Chaquetas') {
          itemCategory2 = 'Chaquetas y Kimonos';
        } else if (typeOfProduct == 'Faldas') {
          itemCategory2 = 'Faldas';
        } else if (typeOfProduct == 'Jerséis' || typeOfProduct == 'Cárdigans' || typeOfProduct == 'Ponchos') {
          itemCategory2 = 'Jerséis y Cárdigans';
        } else if (typeOfProduct == 'Pantalones') {
          itemCategory2 = 'Pantalones';
        } else if (typeOfProduct == 'Sudaderas') {
          itemCategory2 = 'Sudaderas';
        } else if (typeOfProduct == 'Tops') {
          itemCategory2 = 'Tops';
        } else if (typeOfProduct == 'Vaqueros') {
          itemCategory2 = 'Vaqueros';
        } else if (typeOfProduct == 'Vestidos' || typeOfProduct == 'Monos') {
          itemCategory2 == 'Vestidos y Monos';
        }

        let itemCategory = '';
        if (itemCategory2 == 'Accesorios') {
          itemCategory = 'Accesorios';
        } else if (itemCategory2 == 'Bisutería') {
          itemCategory = 'Bisutería';
        } else {
          itemCategory = 'Ropa';
        }

        if (name == 'minus' || name == 'remove') {
          const quantity = parseFloat(lineItem?.querySelector('.quantity__input')?.value);
          const priceRegular = parseFloat(
            lineItem?.querySelector('.price-item--regular')?.innerText.replace(',', '').replace('.', '')
          );

          parsedState.productPrice = (priceRegular / quantity / 100).toFixed(2) || parsedState.items_removed[0].price;
          const discount = parsedState.items_removed[0].price - parsedState.productPrice;
          parsedState.discount = (discount / quantity / 100).toFixed(2);
          parsedState.itemCopy = lineItem?.querySelector(`[name="${name}"]`).innerText;

          const newObj = {
            event_category: 'ecommerce',
            currency: 'EUR',
            tipo_carrito: window.location.pathname.includes('/cart') ? 'página de carrito' : 'minicarrito',
            method: name == 'minus' || name == 'remove' ? 'botón' : 'texto',
            items: [
              {
                item_id: parsedState.items_removed[0].variant_id.toString(),
                item_name: parsedState.items_removed[0].title.split(' - ')[0],
                quantity: quantity,
                price: parseFloat(parsedState.items_removed[0].price),
                discount: parsedState.discount,
                coupon: '',
                item_brand: 'renatta&go',
                item_category: itemCategory,
                item_category2: itemCategory2,
                item_category3: parsedState.items_removed[0].product_type,
                item_variant: parsedState.items_removed[0].title.split(' - ')[1].split(' / ')[0],
                affiliation: '',
                location_id: '',
                index: parseFloat(lineItem?.id.split('CartDrawer-Item-')[1]),
                item_list_name: viewListId,
                item_list_id: document.title.split(' | ')[0],
                promotion_name: sessionStorage.getItem('promotion_name') || '',
                promotion_id: sessionStorage.getItem('promotion_id') || '',
                img_articulo: parsedState.items_removed[0].image,
                color: parsedState.items_removed[0].title.split(' - ')[1].split(' / ')[1],
                precio_articulo: parseFloat(parsedState.items_removed[0].price),
                descuento_articulo: parsedState.discount,
                stock: stock,
                tallas_disponibles: availableSizes,
                tallas_no_disponibles: unavailableSizes,
                score_stock: scoreStock,
                modelo_articulo: model,
              },
            ],
          };
          gtag('event', 'remove_from_cart', newObj);
        }

        if (name == 'plus') {
          const quantity = parseFloat(lineItem.querySelector('.quantity__input').value);
          const priceRegular = parseFloat(
            lineItem.querySelector('.price-item--regular').innerText.replace(',', '').replace('.', '')
          );
          parsedState.productPrice = priceRegular;
          // console.log("lineItem.querySelector('.price-item--regular')", parseFloat(parsedState.items_added[0].price), parseFloat(parsedState.productPrice))
          const discount =
            parseFloat(parsedState.items_added[0].price.replace(',', '').replace('.', '')) -
            parseFloat(parsedState.productPrice);
          parsedState.discount = discount.toFixed(2);
          // console.log('name plus', name, parsedState)
          const newObj = {
            event_category: 'ecommerce',
            currency: 'EUR',
            tipo_carrito: window.location.pathname.includes('/cart') ? 'página de carrito' : 'minicarrito',
            method: name == 'plus' ? 'botón' : 'texto',
            items: [
              {
                item_id: parsedState.items_added[0].variant_id.toString(),
                item_name: parsedState.items_added[0].title.split(' - ')[0],
                quantity: quantity,
                price: parseFloat(parsedState.items_added[0].price),
                discount: parsedState.discount,
                coupon: '',
                item_brand: 'renatta&go',
                item_category: itemCategory,
                item_category2: itemCategory2,
                item_category3: parsedState.items_added[0].product_type,
                item_variant: parsedState.items_added[0].title.split(' - ')[1].split(' / ')[0],
                affiliation: '',
                location_id: '',
                index: parseFloat(lineItem?.id.split('CartDrawer-Item-')[1]),
                item_list_name: viewListId,
                item_list_id: document.title.split(' | ')[0],
                promotion_name: sessionStorage.getItem('promotion_name') || '',
                promotion_id: sessionStorage.getItem('promotion_id') || '',
                img_articulo: parsedState.items_added[0].image.split('https://cdn.shopify.com/s/')[1],
                color: parsedState.items_added[0].title.split(' - ')[1].split(' / ')[1],
                precio_articulo: parseFloat(parsedState.items_added[0].price),
                descuento_articulo: parsedState.discount,
                stock: stock,
                tallas_disponibles: availableSizes,
                tallas_no_disponibles: unavailableSizes,
                score_stock: scoreStock,
                modelo_articulo: model,
              },
            ],
          };

          gtag('event', 'add_to_cart', newObj);
        }

        /* if(name == 'remove') {
          console.log('name remove btn', name)
          const newObj = {
            'event_category': 'ecommerce',
            'currency': 'EUR',
            'tipo_carrito': window.location.pathname.includes('/cart') ? 'página de carrito' : 'minicarrito',
            'method': name == 'plus' ? 'botón' : 'texto',
            'items': [
              {
                'item_id': parsedState.items_removed[0].variant_id.toString(),
                'item_name': parsedState.items_removed[0].title.split(' - ')[0],
                'quantity': quantity,
                'price': parseFloat(parsedState.items_removed[0].price),
                'discount':parsedState.discount,
                'coupon': '',
                'item_brand': 'renatta&go',
                'item_category': itemCategory,
                'item_category2': itemCategory2,
                'item_category3': parsedState.items_removed[0].product_type,
                'item_variant': parsedState.items_removed[0].title.split(' - ')[1].split(' / ')[0],
                'affiliation': '',
                'location_id': '',
                'index': parseFloat(lineItem?.id.split('CartDrawer-Item-')[1]),
                'item_list_name': viewListId,
                'item_list_id': document.title.split(' | ')[0],
                'promotion_name': sessionStorage.getItem('promotion_name') || '',
                'promotion_id': sessionStorage.getItem('promotion_id') || '',
                'img_articulo': parsedState.items_removed[0].image.split('https://cdn.shopify.com/s/')[1],
                'color': parsedState.items_removed[0].title.split(' - ')[1].split(' / ')[1],
                'precio_articulo': parseFloat(parsedState.items_removed[0].price),
                'descuento_articulo': parsedState.discount,
                'stock': stock,
                'tallas_disponibles': availableSizes,
                'tallas_no_disponibles': unavailableSizes,
                'score_stock': scoreStock,
                'modelo_articulo': model
              }
            ]
          }
          gtag("event", "remove_from_cart", newObj);
        } */
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
